
const Loader = () => (
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
) 

export default Loader;